import styled from '@emotion/styled';
import { css } from '@emotion/core';
import ArrowRight from '../../../../../commons/components/icons/ArrowRight';
import { progressiveLoading } from '../../../../../commons/styles/animations';
import mq from '../../../../../commons/styles/mediaQueries';

const Info = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 16px 16px 0 0;
  ${({ transaction }) => !transaction && progressiveLoading()};
`;

const InfoTitle = styled.h2`
  font-size: ${({ theme }) => theme.sizes.l};
  margin: 0;
  display: flex;
  flex-grow: 1;
  cursor: pointer;
  margin: 0;
  font-weight: ${({ theme }) => theme.fontWeights.normal};

  ${({ active }) =>
    active &&
    css`
      cursor: auto;
    `}

  &:empty {
    padding: 11px;
    ${progressiveLoading()}
  }
`;

const ArrowRightIcon = styled(ArrowRight)`
  color: ${({ theme }) => theme.colors.primary};
  height: 24px;
  width: 24px;
`;

const InfoTitleAnchor = styled.a`
  flex-grow: 1;
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.sizes.l};
  text-decoration: none;

  &:focus {
    outline: none;
    text-decoration: underline;
  }
`;

const InfoTitleLink = styled.span`
  flex-grow: 1;
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.sizes.m};
  text-decoration: none;
  display: block;
  overflow: hidden;
  cursor: pointer;

  &:focus {
    outline: none;
    text-decoration: underline;
  }

  ${mq.desktop} {
    font-size: ${({ theme }) => theme.sizes.l};
  }
`;

const InfoTitleIcon = styled.div`
  ${({ active }) =>
    active &&
    css`
      opacity: 0;
    `}
`;

export default {
  Info,
  InfoTitle,
  ArrowRightIcon,
  InfoTitleAnchor,
  InfoTitleLink,
  InfoTitleIcon,
};
